import { addMonths, format, startOfMonth, subMonths } from 'date-fns'
import { buildCalendarDays, getMaximumAdvanceDate, isDaySelectable, isSameCalendarDay } from '../../../utils/dateTime'
import styles from './CalendarPicker.module.scss'

interface CalendarPickerProps {
  month: Date
  selectedDate: Date | null
  onMonthChange: (month: Date) => void
  onSelectDate: (date: Date) => void
  maximumAdvance?: string | null
  openDays?: Set<number>
}

export function CalendarPicker({
  month,
  selectedDate,
  onMonthChange,
  onSelectDate,
  maximumAdvance,
  openDays,
}: CalendarPickerProps) {
  const days = buildCalendarDays(month)
  const maxDate = getMaximumAdvanceDate({ maximumAdvance })

  return (
    <div className={styles.calendar}>
      <div className={styles.header}>
        <button
          type="button"
          className={styles.monthButton}
          onClick={() => onMonthChange(startOfMonth(subMonths(month, 1)))}
        >
          Previous
        </button>
        <strong className={styles.monthLabel}>{format(month, 'MMMM yyyy')}</strong>
        <button
          type="button"
          className={styles.monthButton}
          onClick={() => onMonthChange(startOfMonth(addMonths(month, 1)))}
        >
          Next
        </button>
      </div>

      <div className={styles.weekdays}>
        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
          <div key={day} className={styles.weekday}>
            {day}
          </div>
        ))}
      </div>

      <div className={styles.days}>
        {days.map((day) => {
          const disabled = !isDaySelectable(day, month, maxDate, openDays)
          const selected = isSameCalendarDay(selectedDate, day)

          return (
            <button
              key={day.toISOString()}
              type="button"
              disabled={disabled}
              onClick={() => onSelectDate(day)}
              className={`${styles.day} ${selected ? styles.daySelected : ''}`}
            >
              {format(day, 'd')}
            </button>
          )
        })}
      </div>
    </div>
  )
}
